import { FormState } from './enums';
import { StarsStep } from './Steps/StarsStep';
import { ExamCenterStep } from './Steps/ExamCenterStep';
import { StudyTypeStep } from './Steps/StudyTypeStep';
import { DataTransferStep } from './Steps/DataTransferStep';
import { DrivingSchoolsType } from '../constants';

export const SCREENS_TRANSITIONS = {
  [FormState.Stars]: {
    next: FormState.ExamCenter,
    node: StarsStep,
    prev: undefined,
    step: 1,
  },
  [FormState.ExamCenter]: {
    next: FormState.StudyType,
    node: ExamCenterStep,
    prev: FormState.Stars,
    step: 2,
  },
  [FormState.StudyType]: {
    next: (drivingSchoolType, helpSearchSchool) => {
      if (helpSearchSchool === '1' && drivingSchoolType !== DrivingSchoolsType.TRADITIONAL) {
        return FormState.DataTransferForm;
      }

      return undefined;
    },
    node: StudyTypeStep,
    prev: FormState.ExamCenter,
    step: 3,
  },
  [FormState.DataTransferForm]: {
    next: undefined,
    node: DataTransferStep,
    prev: FormState.StudyType,
    step: 4,
  },
};
